import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import jwtDecode from "jwt-decode";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { useStyles } from "./UserLogin.css";
import Axios from "axios";
import { url } from "../../../Config/Config";
import { userLogin } from "../../../Redux/Actions/actions";
import { connect } from "react-redux";
import LoginSchoolDetails from "./LoginSchoolDetails/LoginSchoolDetails";
import FormLoader from "../../../Components/FormLoader/FormLoader";

class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: "",
        password: "",
        role: "",
      },
      showPassword: false,
      schoolDetails: {},
      isEmpty: false,
      loginError: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    this.getSchoolInfo();
  }

  getSchoolInfo = async () => {
    try {
      const response = await Axios.get(`${url}/api/setting`);
      console.log(response.data);
      if (response.data._id) {
        this.setState({
          schoolDetails: response.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          schoolDetails: {},
          isEmpty: true,
        });
      }
    } catch (error) {
      console.clear();
      this.setState({ schoolDetails: {}, isEmpty: true });
    }
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  decodeToken = (token) => {
    try {
      let decodedData = jwtDecode(token);
      return decodedData.aud;
    } catch (error) {
      console.log(error.response.data);
    }
  };

  checkError = (error) => {
    let loginError = error ? error : "";
    if (loginError) {
      this.setState({ loginError });
      return true;
    } else {
      this.setState({ loginError: "" });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ isLoading: true });
        if (this.state.data.role === "Student") {
          let data = {
            admissionId: this.state.data.username,
            password: this.state.data.password,
          };
          const studentResponse = await Axios.post(
            `${url}/api/login/student`,
            data
          );
          if (
            studentResponse.data.accessToken &&
            studentResponse.data.refreshToken
          ) {
            let studentId = this.decodeToken(studentResponse.data.accessToken);
            this.props.userLogin(
              studentId,
              studentResponse.data.accessToken,
              studentResponse.data.refreshToken,
              this.state.data.role
            );
          }
        } else if (this.state.data.role === "Parent") {
          let data = {
            phoneNo: this.state.data.username,
            password: this.state.data.password,
          };
          const parentResponse = await Axios.post(
            `${url}/api/login/parent`,
            data
          );
          if (
            parentResponse.data.accessToken &&
            parentResponse.data.refreshToken
          ) {
            let studentId = this.decodeToken(parentResponse.data.accessToken);
            this.props.userLogin(
              studentId,
              parentResponse.data.accessToken,
              parentResponse.data.refreshToken,
              this.state.data.role
            );
          }
        } else if (this.state.data.role === "Teacher") {
          let data = {
            mobileNumber: this.state.data.username,
            password: this.state.data.password,
          };
          const teacherResponse = await Axios.post(
            `${url}/api/login/teacher`,
            data
          );
          if (
            teacherResponse.data.accessToken &&
            teacherResponse.data.refreshToken
          ) {
            let teacherId = this.decodeToken(teacherResponse.data.accessToken);
            this.props.userLogin(
              teacherId,
              teacherResponse.data.accessToken,
              teacherResponse.data.refreshToken,
              this.state.data.role
            );
          }
        }
      } catch (error) {
        this.setState({ isLoading: false });
        if (
          error.response.status === 500 &&
          error.response.data.message === "validateInput is not defined"
        ) {
          console.clear();
          this.checkError("Please Check the role is correct or not");
        }
        if (
          error.response.data.error ===
          '"admissionId" length must be less than or equal to 9 characters long'
        ) {
          console.clear();
          this.checkError("Please Check the role is correct or not");
        }
        if (
          error.response.data.error ===
          '"mobileNumber" length must be at least 10 characters long'
        ) {
          console.clear();
          this.checkError("Please Check the role is correct or not");
        }
        if (error.response.data.message === "Invalid credentials") {
          console.clear();
          this.checkError("Invalid Credentials, Please try again");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { schoolDetails } = this.state;
    return (
      <div className={classes.root}>
        {this.state.isEmpty ? (
          <h3>School Management System</h3>
        ) : (
          <LoginSchoolDetails schoolDetails={schoolDetails} />
        )}
        <form onSubmit={this.handleSubmit}>
          <TextField
            name="username"
            type="username"
            label="Username"
            fullWidth
            required
            error={this.state.loginError ? true : false}
            margin="normal"
            variant="outlined"
            placeholder="Enter username provided"
            style={{ outline: "none" }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.username}
            onChange={this.handleChange}
          />

          <TextField
            name="password"
            type={this.state.showPassword ? "text" : "password"}
            label="Password"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Enter password provided"
            style={{ outline: "none" }}
            error={this.state.loginError ? true : false}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showPassword
                ? this.hidePassword()
                : this.showPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.password}
            onChange={this.handleChange}
          />

          <TextField
            name="role"
            select
            label="Category"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            error={this.state.loginError ? true : false}
            style={{ outline: "none" }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.role}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            <option value="Student">Student</option>
            <option value="Parent">Parent</option>
            <option value="Teacher">Teacher</option>
          </TextField>

          {this.state.loginError && (
            <div style={{ color: "red" }}>{this.state.loginError}</div>
          )}

          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="submit"
              variant="outlined"
              className={classes.buttonStyle}
            >
              Submit
            </Button>
            {this.state.isLoading && <FormLoader />}
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userLogin: (userId, token, refreshToken, role) => {
      dispatch(userLogin(userId, token, refreshToken, role));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(useStyles)(UserLogin));
